import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ArrowDownIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 12 16">
        <g clipPath="url(#clip0_2893_761)">
            <path d="M5.99997 12C5.74409 12 5.48809 11.9023 5.29309 11.707L0.293091 6.70703C-0.0975342 6.31641 -0.0975342 5.68359 0.293091 5.29297C0.683716 4.90234 1.31653 4.90234 1.70715 5.29297L5.99997 9.5875L10.2937 5.29375C10.6843 4.90312 11.3172 4.90312 11.7078 5.29375C12.0984 5.68437 12.0984 6.31719 11.7078 6.70781L6.70778 11.7078C6.51247 11.9031 6.25622 12 5.99997 12Z" fill="#9CA5B6"/>
        </g>
        <defs>
            <clipPath id="clip0_2893_761">
                <rect width="12" height="16" />
            </clipPath>
        </defs>
    </SvgIcon>
);
